import React from "react";
const About = () => {
  return (
    <div  className=" h-[30rem]  text-xl text-black ">
     <h1 className=" text-center  text-4xl pt-7 lg:pt-4  "> About </h1>
      <div className="lg:flex lg:justify-center lg:items-center lg:pt-5 gap-20">
        <p className=" text-center sm:text-start p-4  lg:w-80   border-red-950  ">
        I'm Roderick, but you can call me Derek. I graduated with a bachelor’s degree in Computer Science. 
      </p>
      <div> 
        <section className=" text-center lg:text-start text-2xl ">
          <strong>Skills</strong> 
        </section>
        <div className="flex justify-center p-5 sm:p-0"> 
            <div className="   object-contain grid grid-cols-3 justify-items-center content-center gap-2 w-96 p-5 border-solid border-2 rounded-xl bg-gray-700">
              <div>
                <img className=" flex justify-center sm:h-18 h-12 cursor-pointer hover:scale-125 duration-500  hover:grayscale-0" src='https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/javascript/javascript-original.svg' alt=""/>
             </div>
                <div>
                    <img className="flex justify-center sm:h-18  h-12  cursor-pointer hover:scale-125 duration-500  hover:grayscale-0" src='https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/html5/html5-original.svg' alt=""/>
                </div>
             <div>
                <img className="flex justify-center sm:h-18   h-12  cursor-pointer hover:scale-125 duration-500  hover:grayscale-0" src='https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/css3/css3-original.svg' alt=""/>
            </div>
              <div>
                <div className="">
                    <img className="sm:h-18  h-12  cursor-pointer hover:scale-125 duration-500  hover:grayscale-0" src='https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/tailwindcss/tailwindcss-plain.svg' alt=""/>
                </div>
            </div>
               <div>
                <img className="flex justify-center sm:h-18  h-12 cursor-pointer hover:scale-125 duration-500  hover:grayscale-0" src='https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/react/react-original.svg' alt=""/>
            </div>
            <div>
                    <img className="flex justify-center sm:h-18  h-12 rounded-md p-1 cursor-pointer hover:scale-125 duration-500  hover:grayscale-0 " src='https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/github/github-original.svg' alt=""/>
                </div>
                <div>
                    <img className="flex justify-center sm:h-18   h-12 rounded-md p-1 cursor-pointer hover:scale-125 duration-500  hover:grayscale-0" src='https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/git/git-original.svg' alt=""/>
                </div>
                <div>
                    <img className="flex justify-center sm:h-18  h-12  rounded-md p-1 cursor-pointer hover:scale-125 duration-500  hover:grayscale-0" src='https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/npm/npm-original-wordmark.svg' alt=""/>
                </div>
                <div>
                    <img className="flex justify-center sm:h-18  h-12  rounded-md p-1 cursor-pointer hover:scale-125 duration-500  hover:grayscale-0" src='https://cdn.jsdelivr.net/npm/devicon@2.15.1/icons/nodejs/nodejs-original.svg' alt=""/>
                </div>
                <div>
                    <img className="flex justify-center sm:h-18  h-12  rounded-md p-1 cursor-pointer hover:scale-125 duration-500  hover:grayscale-0" src='https://cdn.jsdelivr.net/npm/devicon@2.16.0/icons/express/express-original.svg' alt=""/>
                </div>
            </div>
            </div>
        </div>
        </div>
        </div>
  );
};

export default About;